// src/data.js

export const hobbies = [
    {
      title: "Github",
      subtitle: "My for fun coding",
      description:
        "Check out some of my projects where I worked with web apps, machine learning, and data visualization!",
      image: "./coding.jpg",
      link: "https://github.com/frankclong",
      target : "_blank",
    },
    {
      title: "Wine",
      subtitle: "My journey",
      description:
        "Follow my journey into the beautiful world of fermented grape juice",
      image: "./wine.jpg",
      link: "#wine",
      target : "",
    },
    {
      title: "Chess",
      subtitle: "En passant",
      description:
        "Track my progress as I flip flop between wanting to become a national master and hating chess",
      image: "./chess.png",
      link: "#chess", 
      target : "",
    },
    {
      title: "Basketball",
      subtitle: "Roy Hibbert fan",
      description:
        "Reguarly playing drop-in ball. Keeping up with the NBA - go Pacers go!",
      image: "./basketball.webp",
      link: "",
      target : "",
    },
    {
      title: "Drawing, Painting, Sketching",
      subtitle: "Art",
      description:
        "Capturing the rare spouts of inspiration",
      image: "./drawing.png",
      link: "#drawing",
      target : "",
    },
    {
      title: "Manga",
      subtitle: "Japanese Comics",
      description:
        "A picture is worth a thousand words",
      image: "./manga.jpg",
      link: "https://myanimelist.net/profile/dragonsp",
      target : "_blank",
    },
    {
      title: "Plants",
      subtitle: "Low maintenance pets",
      description:
        "The joys and pains of life and death",
      image: "./plants.jpg",
      link: "#plants",
      target : "",
    },
    {
      title: "Crochet",
      subtitle: "I'm hooked",
      description:
        "Learned with a Woobles kit!",
      image: "./crochet.jpeg",
      link: "#crochet",
      target : "",
    },
    {
      title: "Travel",
      subtitle: "Exploring the world",
      description:
        "Where will my feet take me next?",
      image: "./travel.jpeg",
      link: "#travel",
      target : "",
    },
    {
      title: "Bouldering",
      subtitle: "Overhang avoider",
      description:
        "Hardstuck V3 climber",
      image: "./bouldering.webp",
      link: "",
      target : "",
    },
    {
      title: "Video Games",
      subtitle: "Variety",
      description:
        "Currently playing League of Legends and Europa Universalis IV",
      image: "./video-games.webp",
      link: "",
      target : "",
    },
    {
      title: "Volleyball",
      subtitle: "Spike, Spike, Spike",
      description:
        "I still can't pass",
      image: "./volleyball.jpg",
      link: "",
      target : "",
    },
    {
      title: "Running",
      subtitle: "zoom zoom",
      description:
        "Currently training for a half-marathon!",
      image: "./running.png",
      link: "https://www.strava.com/athletes/105805493",
      target : "_blank",
    },
    {
      title: "Reading",
      subtitle: "Fantasy and Historical Fiction",
      description:
        "People have amazing stories to tell",
      image: "./reading.jpeg",
      link: "https://www.goodreads.com/user/show/103212523-frank-long",
      target : "_blank",
    },
    {
      title: "Skiing/Snowboarding",
      subtitle: "Hitting the slopes",
      description:
        "Beginner snowboarder. Intermediate skiier. Advanced fun-haver.",
      image: "./skiing.webp",
      link: "",
      target : "",
    },
    {
      title: "Making Music",
      subtitle: "Acoustic covers",
      description:
        "Tough to make time but when a song stands out I gotta do what I gotta do",
      image: "./music.avif",
      link: "https://www.youtube.com/watch?v=UhK1KZykmVI",
      target : "_blank",
    },
    {
      title: "Languages",
      subtitle: "French and Mandarin",
      description:
        "Slow and steady journey to fluency",
      image: "./languages.jpg",
      link: "#languages",
      target : "",
    },
  ];